import React, { useEffect } from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer';
import StatsSection from '../../components/StatsSection';
import ProcessSection from '../../components/ProcessSection';
import Newsletter from '../../components/Newsletter';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";

const FaqItem = ({ question, answer, defaultOpen = false }) => {
  const [open, setOpen] = React.useState(defaultOpen);
  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button
          className={`accordion-button ${open ? '' : 'collapsed'}`}
          type="button"
          onClick={() => setOpen(prev => !prev)}
        >
          {question}
        </button>
      </h2>
      <div className={`accordion-collapse collapse ${open ? 'show' : ''}`}> 
        <div className="accordion-body">{answer}</div>
      </div>
    </div>
  );
};

export default function PatchDigitizing() {

    const patchSteps = [
        { number: "01", title: "Submit Your Design", description: "Send your artwork, logo, or patch in JPG, PNG, PDF, or AI format.", icon: "📤" },
        { number: "02", title: "Patch Digitizing", description: "We convert your design into a machine-ready stitch file optimized for patch embroidery.", icon: "⚡" },
        { number: "03", title: "Quality Check", description: "We refine stitch paths, density, and edges for clean, accurate results.", icon: "✓" },
        { number: "04", title: "File Delivery", description: "Receive your embroidery files in DST, PES, JEF, and other compatible formats.", icon: "🚀" }
    ];

    return (
        <>

            <Helmet>
                <title>Embroidery Patch Digitizing Services Los Angeles, CA | Grand Indigo Embroidery</title>
                <meta name="description" content="Get custom embroidery patch digitizing services in Los Angeles, CA. High-quality stitch files for patches and badges." />
                <meta name="keywords" content="patch digitizing, embroidery patch digitizing, custom patch digitizing, patch logo digitizing, Los Angeles embroidery digitizing" />
            </Helmet>

            <Header />

            <section className="breadcrumbsection">
                <div className='container'>
                    <h1>Patch Digitizing</h1>
                    <ul className='breadcrumblinks'>
                        <li><Link to="/">Home</Link></li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Services</li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>PatchDigitizing</li>
                    </ul>
                </div>
            </section>


            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/patchditizing1.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Defined Edges. Durable Finish.</span>
                                <h3 className="case-study-title">Expert Patch Digitizing Services in Los Angeles</h3>
                                <p className="case-study-description">
                                    At Grand Indigo Embroidery, we provide professional patch digitizing services in Los Angeles, California, helping organizations, businesses, and clubs create precise embroidery files for custom patches. Digitizing patches requires careful attention to design size, stitch density, and shape to ensure clean, professional results that are ready for production.
                                </p>
                                <p className="case-study-description">
                                    Whether you need patches for uniforms, jackets, hats, or promotional items, our patch embroidery digitizing services ensure your designs retain their details, colors, and overall integrity. If you’re searching for reliable patch digitizing near you in Los Angeles, Grand Indigo Embroidery delivers accurate, high-quality, and machine-ready files for all patch applications.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <StatsSection />

            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Built for Clean Borders & Smooth Runs</span>
                                <h3 className="case-study-title">Custom Patch Digitizing for Uniforms & Branding</h3>
                                <p className="case-study-description">
                                    Our custom patch digitizing services are tailored for businesses, schools, sports teams, and clubs that want professional embroidery-ready files. We optimize every stitch for your design, fabric type, and patch shape to ensure flawless results.
                                </p>
                                <p className="case-study-description">
                                    From simple logos to intricate decorative patches, we create embroidery files ready for production on all major embroidery machines. Los Angeles clients trust Grand Indigo Embroidery for fast turnaround, precise results, and high-quality patch digitizing. You can also order patch embroidery digitizing online to get ready-to-use files conveniently.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/patchditizing2.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <ProcessSection steps={patchSteps} />
                                                
            <section className="faqs-section">
                <div className="container">
                    <div className="row mb-5">
                        <div className="col-12 text-center">
                            <h2 className="section-title">Frequently Asked Questions</h2>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="accordion" id="faqAccordion">

                                <FaqItem
                                    defaultOpen={true}
                                    question="What is patch digitizing?"
                                    answer="Patch digitizing is the process of converting logos or designs into machine-readable embroidery files for creating custom patches."
                                />

                                <FaqItem
                                    question="Do you offer patch digitizing services in Los Angeles?"
                                    answer="Yes, Grand Indigo Embroidery provides professional patch embroidery digitizing services in Los Angeles, California."
                                />

                                <FaqItem
                                    question="Can I order patch digitizing online?"
                                    answer="Absolutely. You can order patch embroidery digitizing online and receive optimized files quickly."
                                />

                                <FaqItem
                                    question="What types of patches can you digitize?"
                                    answer="We can digitize logo patches, decorative patches, uniform patches, and custom designs of any shape or size."
                                />

                                <FaqItem
                                    question="What garments or items can use patch embroidery?"
                                    answer="Patch embroidery can be applied to jackets, hats, uniforms, bags, and promotional items."
                                />

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Newsletter />

            <Footer />
        </>
    )
}
